module.exports = __webpack_public_path__ + "static/sample-7-d0e9b3f8fb8a7afb86001add743a58c0.png";